import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProjectContainer from './containers/ProjectContainer';
import HomeContainer from './containers/HomeContainer';
import NavBar from './components/NavBar';
import Contact from './components/Contact';
import AboutMe from './components/AboutMe';

function App() {
  return (
    <div className="App">
      <h1><a href="/aneeqayusafportfolio/">Aneeqa Yusaf is currently under construction</a></h1>
      <HomeContainer />
      <AboutMe />
      <Router>
        <NavBar />
        <Routes>
          <Route path="/aneeqayusafportfolio" element={< HomeContainer />} />
          <Route path="/aneeqayusafportfolio/projects" element={< ProjectContainer />} />
          <Route path="/aneeqayusafportfolio/contact" element={< Contact />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
